import { lazy, Suspense, useState } from "react";
import Logo from "common/svg/logo.svg";
import { Link } from "react-router-dom";
import { CloseCrossIcon } from "@/common/icons/CloseCrossIcon";
import BurgerIcon from "@/common/svg/menu.svg";
import { LangSwitcher } from "@/features/LangSwitcher";

const Drawer = lazy(
  () =>
    import(
      /* webpackChunkName: "drawer", webpackPrefetch: true */ "@/widgets/Drawer"
    ),
);

const MobileHeader = () => {
  const [drawerVisible, setDrawerVisible] = useState(false);

  const toggleDrawer = async () => {
    setDrawerVisible((prev) => !prev);
  };

  return (
    <>
      <header className="bg-light sticky top-0 z-40 flex h-[var(--header-height)] shrink-0 items-center justify-between px-4">
        <div className="flex items-center gap-4">
          <LangSwitcher />
          <Link
            id="logo-link"
            className="flex items-center gap-1"
            to="/"
            onClick={() => setDrawerVisible(false)}
          >
            <Logo />
          </Link>
        </div>
        <button onClick={toggleDrawer}>
          {drawerVisible ? <CloseCrossIcon /> : <BurgerIcon />}
        </button>
      </header>
      <Suspense fallback={null}>
        <Drawer visible={drawerVisible} onClose={toggleDrawer} />
      </Suspense>
    </>
  );
};

export default MobileHeader;
